import { Component, Inject, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface CustomSnackbarData {
  title: string;
  descriptions: string[];
  action: string;
}

@Component({
    selector: 'app-custom-snackbar',
    templateUrl: './custom-snackbar.component.html',
    styleUrls: ['./custom-snackbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CustomSnackbarComponent implements OnInit {
  snackBarRef = inject(MatSnackBarRef);
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: CustomSnackbarData) { }

  ngOnInit(): void {
  }

  dismiss(){
    this.snackBarRef.dismiss();
  }

}
